import { render, staticRenderFns } from "./OrganizationUserSlug.vue?vue&type=template&id=c6d8e9c6&"
import script from "./OrganizationUserSlug.vue?vue&type=script&lang=ts&"
export * from "./OrganizationUserSlug.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports